import React from "react";
import { Link } from "react-router-dom";

const OurNetwork = () => {
  const routes = [
    {
      title: "Pune Cab Fare",
      image: "/images/network/Pune-cab-fare.png",
      link: "/pune-cab-fare",
    },
    {
      title: "Pune Outstation Cabs",
      image: "/images/network/Pune-Outstation-Cabs.png",
      link: "/pune-outstation-cabs",
    },
    {
      title: "Pune to Bhimashankar Cab",
      image: "/images/network/Pune-to-Bhimashankar-Cab.png",
      link: "/pune-to-bhimashankar-cab",
    },
    {
      title: "Pune to Delhi Cabs",
      image: "/images/network/Pune-to-Delhi-cabs.png",
      link: "/pune-to-delhi-cabs",
    },
    {
      title: "Pune to Indore Cabs",
      image: "/images/network/Pune-to-Indore-cabs.png",
      link: "/pune-to-indore-cabs",
    },
    {
      title: "Pune to Lavasa Cabs",
      image: "/images/network/Pune-to-Lavasa-Cabs.png",
      link: "/pune-to-lavasa-cabs",
    },
    {
      title: "Pune to Mumbai Cabs",
      image: "/images/network/Pune-to-Mumbai-cabs.png",
      link: "/pune-to-mumbai-cabs",
    },
    {
      title: "Pune to Nasik Cabs",
      image: "/images/network/Pune-to-Nasik-cabs.png",
      link: "/pune-to-nasik-cabs",
    },
    {
      title: "Pune to Shirdi Cabs",
      image: "/images/network/Pune-to-Shirdi-cabs.png",
      link: "/pune-to-shirdi-cabs",
    },
  ];

  return (
    <>
      {/* Breadcrumb */}
      <div
        className="breadcumb-wrapper"
        style={{
          background:
            "linear-gradient(rgba(0,87,217,0.75), rgba(255,107,0,0.75)), url('/images/breadcrumb.jpg') center/cover",
          padding: "100px 0",
          position: "relative",
        }}
      >
        <div className="container">
          <div className="text-center">
            <h1
              style={{
                color: "#fff",
                fontSize: "48px",
                fontWeight: "800",
                marginBottom: "10px",
              }}
            >
              Our Network
            </h1>

            <p
              style={{
                color: "#fff",
                fontSize: "18px",
                margin: 0,
              }}
            >
              Trusted Cab Services Across Popular Routes
            </p>
          </div>
        </div>
      </div>

      {/* Network Section */}
      <section
        style={{
          padding: "80px 0",
          background: "#f8fafc",
        }}
      >
        <div className="container">
          {/* Heading */}
          <div className="text-center mb-5">
          

            {/* <h2
              style={{
                fontWeight: "800",
                color: "#0057D9",
              }}
            >
              Popular Cab Routes
            </h2>

            <p
              style={{
                maxWidth: "700px",
                margin: "10px auto",
                color: "#666",
              }}
            >
              Explore our most booked routes with safe, reliable and affordable
              cab services from Rising Cab Service.
            </p> */}
          </div>

          {/* Cards */}
          <div className="row">
            {routes.map((item, index) => (
              <div className="col-lg-4 col-md-6 mb-4" key={index}>
                <Link
                  to={item.link}
                  style={{
                    textDecoration: "none",
                  }}
                >
                  <div
                    style={{
                      borderRadius: "18px",
                      overflow: "hidden",
                      background: "#fff",
                      boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
                      transition: "0.3s ease",
                    }}
                  >
                    <img
                      src={item.image}
                      alt={item.title}
                      style={{
                        width: "100%",
                        height: "240px",
                        objectFit: "cover",
                      }}
                    />

                    <div
                      style={{
                        background:
                          "linear-gradient(135deg,#0057D9,#FF6B00)",
                        padding: "18px",
                        textAlign: "center",
                      }}
                    >
                      <h3
                        style={{
                          color: "#fff",
                          fontSize: "22px",
                          fontWeight: "700",
                          margin: 0,
                        }}
                      >
                        {item.title}
                      </h3>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default OurNetwork;